module.exports = __webpack_public_path__ + "static/img/-s-4.61fa09f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/-s-4.png
// module id = DwIH
// module chunks = 0